import { GET_ROUTE_TO_COMPANY, FETCH_VESSSEL_ROUTE_SUCCESS, FETCH_VESSSEL_ROUTE_FAILURE, FETCH_VESSEL_DETAIL_BY_ID_SUCCESS, FETCH_VESSEL_DETAIL_BY_ID, FETCH_VESSEL_DETAIL_BY_ID_FAILURE } from '../action/vessels.action'
import { apiRequest } from "../action/api.action"

export const vesselsFlow = ({ dispatch }) => next => action => {

  next(action)

  if (action.type === GET_ROUTE_TO_COMPANY) {
    let url = `/api/v1/vessels/${action.payload.imo}/route-to-shipyard/${action.payload.companyId}`;
    dispatch(apiRequest('GET', url, null, FETCH_VESSSEL_ROUTE_SUCCESS, FETCH_VESSSEL_ROUTE_FAILURE));
  } else if (action.type === FETCH_VESSEL_DETAIL_BY_ID) {
    let url = `/api/v1/equipments/by-detail/${action.payload}`;
    dispatch(apiRequest('GET', url, null, FETCH_VESSEL_DETAIL_BY_ID_SUCCESS, FETCH_VESSEL_DETAIL_BY_ID_FAILURE));
  }
};

export const vesselsMdl = [vesselsFlow];